import { render, staticRenderFns } from "./PatientDiagnoseRecord.vue?vue&type=template&id=6abe3f30&scoped=true&"
import script from "./PatientDiagnoseRecord.vue?vue&type=script&lang=js&"
export * from "./PatientDiagnoseRecord.vue?vue&type=script&lang=js&"
import style0 from "./PatientDiagnoseRecord.vue?vue&type=style&index=0&lang=less&"
import style1 from "./PatientDiagnoseRecord.vue?vue&type=style&index=1&id=6abe3f30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abe3f30",
  null
  
)

export default component.exports